import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronLeft, ChevronRight } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { format as formatDate } from "__barrel_optimize__?names=format!=!date-fns";
export const DateInputHeader = (param)=>{
    let { date, prevMonthButtonDisabled, nextMonthButtonDisabled, increaseMonth, decreaseMonth } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mb-3 flex items-center justify-between",
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                color: "grey",
                onClick: decreaseMonth,
                disabled: prevMonthButtonDisabled,
                icon: ChevronLeft,
                size: "small",
                label: "Show previous month"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "text-12 font-medium text-grey-11",
                children: formatDate(date, "MMMM yyyy")
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                color: "grey",
                onClick: increaseMonth,
                disabled: nextMonthButtonDisabled,
                icon: ChevronRight,
                size: "small",
                label: "Show next month"
            })
        ]
    });
};
